module.exports = __webpack_public_path__ + "img/undraw_no_data_re_kwbl.bf0275f7.svg";